import React, { useState, useEffect } from "react";

export default function DateTimeRangePicker({ onApply, startDateTime, endDateTime }) {
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [error, setError] = useState("");

  const convertToInputFormat = (dateTimeStr) => {
    if (!dateTimeStr) return "";
    return dateTimeStr.replace(" ", "T");
  };

  const convertToBackendFormat = (dateTimeStr) => {
    if (!dateTimeStr) return "";
    return dateTimeStr.replace("T", " ");
  };

  // 🔹 Sync props to state
  useEffect(() => {
    if (startDateTime) {
      setStart(convertToInputFormat(startDateTime));
    }
    if (endDateTime) {
      setEnd(convertToInputFormat(endDateTime));
    }
  }, [startDateTime, endDateTime]);

  const handleApply = () => {
    if (!start || !end) {
      setError("Please select both start and end date-time.");
      return;
    }

    if (new Date(end) < new Date(start)) {
      setError("End date-time cannot be before start date-time.");
      return;
    }

    setError("");
    // Convert back to backend format before calling onApply
    onApply({ 
      start: convertToBackendFormat(start), 
      end: convertToBackendFormat(end) 
    });
  };

  return (
    <div className="d-flex align-items-end flex-wrap gap-3 p-3 border rounded shadow-sm bg-light">
      {/* Start Date & Time */}
      <div className="d-flex flex-column">
        <label className="form-label fw-semibold small mb-1">
          Start Date & Time
        </label>
        <input
          type="datetime-local"
          value={start}
          onChange={(e) => setStart(e.target.value)}
          className="form-control"
          style={{ minWidth: "220px" }}
          placeholder="Start Date & Time"
        />
      </div>

      {/* End Date & Time */}
      <div className="d-flex flex-column">
        <label className="form-label fw-semibold small mb-1">
          End Date & Time
        </label>
        <input
          type="datetime-local"
          value={end}
          onChange={(e) => setEnd(e.target.value)}
          className="form-control"
          style={{ minWidth: "220px" }}
          placeholder="End Date & Time"
        />
      </div>

      {/* Apply Button */}
      <div className="d-flex flex-column justify-content-end">
        <button 
          className="btn btn-primary mt-auto" 
          onClick={handleApply}
          disabled={!start || !end}
        >
          Apply
        </button>
      </div>

      {/* Error Message */}
      {error && <div className="w-100 text-danger small mt-2">{error}</div>}
    </div>
  );
}